import React from "react";
import {
  Box,
  Typography,
  Grid,
  Paper,
  Avatar,
  Stack,
  Divider,
  Chip,
  Button
} from "@mui/material";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import {
  TwoWheeler,
  Engineering,
  OfflineBolt,
  Security,
  Route
} from "@mui/icons-material";

import TourCard from "../Components/Cards/TourCard";
import BikeRentalComponent from "../Components/FillerComponents/Bikeservices";
import SectionHeading from "../Components/UI/Sectionheading";

/* =========================
   MOTORCYCLE TOUR DATA
========================= */
const tourData = [
  {
    id: "sirmour-ride",
    title: "Sirmour & Renuka Ride",
    titlemono: "The Offbeat Trail",
    places: "Nahan • Renuka Ji • Chandpurdhar",
    price: "₹ 12,000/-",
    image:
      "https://himachalstory.com/wp-content/uploads/2018/07/Churdhar-Peak-1068x801.jpg",
    rating: 4.5,
    duration: "4D / 3N",
    Overview:
      "A peaceful and less-crowded ride through southern Himachal, perfect for relaxed cruising and scenic exploration."
  },
  {
    id: "mussoorie-dhanaulti",
    title: "Mussoorie & Dhanaulti Loop",
    titlemono: "Queen of Hills Ride",
    places: "Mussoorie • Dhanaulti • Landour",
    price: "₹ 14,000/-",
    image:
      "https://dwq3yv87q1b43.cloudfront.net/public/blogs/fit-in/1350x300/Blog_20250111-1360644405-1736581012.jpg",
    rating: 4.7,
    duration: "3D / 2N",
    Overview:
      "A perfect weekend escape with winding hill roads, forest stretches, and classic mountain views."
  },
  {
    id: "ll1",
    title: "Leh Ladakh Road Trip",
    places: "Leh • Nubra • Pangong • Khardung La",
    price: "₹ 32,999/-",
    image: "https://media.traveljunky.in/website-assets/sub-navigation/ladakh-tour-packages/68ba9eb95025c.webp",
    rating: 4.8
  },
];

/* =========================
   ENRICH TOUR (REQUIRED)
========================= */
const enrichTour = (tour, index) => {
  const tags = ["Biker Special", "Popular Ride", "Limited Slots"];
  const basePrice = parseInt(tour.price.replace(/[₹,/-]/g, ""));

  return {
    ...tour,
    tag: tags[index % tags.length],
    oldPrice: basePrice + 4000,
    discountEndsIn: "Few Seats Left",
    IncludeExclude:
      "• Bike rental\n• Helmet\n• Accommodation\n• Road Captain",
    CancellationPolicy:
      "• 7 days before: 50% refund\n• Less than 7 days: No refund"
  };
};

const Motorcyclestours = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ bgcolor: "#f7fdf9", px: { xs: 2, md: 6 }, py: 6 }}>

      {/* ================= HERO ================= */}
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }}>
        <Box
          sx={{
            mb: 8,
            textAlign: "center",
            py: 7,
            borderRadius: 4,
            color: "#fff",
            background:
              "linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url(https://images.unsplash.com/photo-1558981806-ec527fa84c39?q=80&w=2000)",
            backgroundSize: "cover",
            backgroundPosition: "center"
          }}
        >
          <Chip
            icon={<TwoWheeler />}
            label="MOTORCYCLE EXPEDITIONS"
            sx={{ mb: 2, bgcolor: "#16a34a", color: "#fff", fontWeight: 700 }}
          />
          <Typography variant="h3" fontWeight={900}>
            Ride the Himalayas
          </Typography>
          <Typography maxWidth="800px" mx="auto" mt={2} lineHeight={1.8}>
            Curated motorcycle tours designed for riders who crave freedom,
            open roads, and unforgettable landscapes.
          </Typography>
        </Box>
      </motion.div>

      {/* ================= RIDES ================= */}
      <SectionHeading heading="Popular Motorcycle Rides" />

      <Grid container spacing={3} mb={10}>
        {tourData.map((tour, index) => (
          <Grid item xs={12} sm={6} md={3} key={tour.id}>
            <TourCard
              tour={tour}
              index={index}
              onViewDetails={() =>
                navigate("/tourdetails", {
                  state: enrichTour(tour, index) // ✅ FIXED
                })
              }
              onEnquire={() => navigate("/booking")}
            />
          </Grid>
        ))}
      </Grid>

      {/* ================= BIKE SERVICES ================= */}
      <BikeRentalComponent />

      {/* ================= RIDER GUIDE ================= */}
      <Grid container spacing={4} mt={6}>
        {[
          {
            icon: <Engineering />,
            title: "Ride Safety",
            text: "Always wear certified riding gear and follow convoy rules."
          },
          {
            icon: <OfflineBolt />,
            title: "Emergency Prep",
            text: "Carry puncture kits, basic tools, and emergency contacts."
          },
          {
            icon: <Security />,
            title: "Documents",
            text: "DL, ID proof, and bike documents are mandatory."
          }
        ].map((item, i) => (
          <Grid item xs={12} md={4} key={i}>
            <Paper sx={{ p: 4, borderRadius: 3, height: "100%" }}>
              <Stack direction="row" spacing={2} alignItems="center" mb={2}>
                <Avatar sx={{ bgcolor: "#16a34a" }}>
                  {item.icon}
                </Avatar>
                <Typography fontWeight={700}>{item.title}</Typography>
              </Stack>
              <Typography color="text.secondary" lineHeight={1.7}>
                {item.text}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>

    </Box>
  );
};

export default Motorcyclestours;
